import { observer } from "mobx-react";
import React, { useEffect } from "react";
import { CustomDataGrid } from "src/Shared/Components";
import { useModal, useStore } from "src/Shared/Hooks";
import { ILeadTypeSetting } from "../../Interfaces/ILeadTypeSetting";
import { leadTypeColumns } from "./LeadTypes.column";
import SettingsService from "../../Services/Settings.service";
import { finalize } from "rxjs";
import { ToastService } from "src/Shared/Services";
import { AxiosError } from "axios";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import { useStyles } from "./LeadTypes.styles";
import { Button } from "@mui/material";
import AddOrEditLeadType from "../AddOrEditLeadType/AddOrEditLeadType";
import { VIEW_MODE } from "src/Shared/Enums/ViewMode.enum";

const LeadTypes: React.FC = () => {
  const classes = useStyles();

  const {
    rootStore: {
      settingsStore: {
        getLeadTypes,
        leadTypeList,
        gridLoading,
        setGridLoading,
      },
    },
  } = useStore();
  const modal = useModal();
  useEffect(() => {
    getLeadTypes();
  }, []);

  const editLeadType = (lead: ILeadTypeSetting) => {
    modal.open(<AddOrEditLeadType mode={VIEW_MODE.EDIT} leadType={lead} />);
  };
  const addLeadType = () => {
    modal.open(<AddOrEditLeadType mode={VIEW_MODE.ADD}  />);
  };
  const toggleStatus = (lead: ILeadTypeSetting) => {
    setGridLoading(true);
    SettingsService.setLeadTypeStatus(lead.leadTypeID, !lead.isActive)
      .pipe(
        finalize(() => {
          setGridLoading(false);
        }),
      )
      .subscribe({
        next: (data: string) => {
          getLeadTypes();
          ToastService.success(data);
        },
        error: (error: AxiosError) => ToastService.axiosError(error),
      });
  };

  return (
    <>
      <div className={classes.main}>
        <Button
          variant="contained"
          onClick={() => {
            addLeadType();
          }}
        >
          <AddCircleIcon />
          Add Lead Type
        </Button>
      </div>
      <CustomDataGrid
        loading={gridLoading}
        rows={leadTypeList || []}
        columns={leadTypeColumns(editLeadType, toggleStatus)}
        getRowId={(row: ILeadTypeSetting) => row.leadTypeID}
        style={{
          height: "calc(100vh - 200px)",
        }}
        onRowDoubleClick={(params) => editLeadType(params.row)}
        hideFooterPagination
      />
    </>
  );
};

export default observer(LeadTypes);
